import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { EmpresaRequest } from "../../requests/usuario/empresa.request";
import { CasasDecimaisRequest } from '../../requests/usuario/casas-decimais.request';
import { EmpresaResponse } from "../../responses/usuario/empresa.response";
import { CasasDecimaisResponse } from '../../responses/usuario/casas-decimais.response';
import { EmpresaCadastroResponse } from '../../responses/usuario/empresa-cadastro.response';
import { ListaEmpresaResponse } from '../../responses/usuario/lista-empresa.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: "root"
})
export class EmpresaService extends CommonService {
    constructor(
        private router: Router,
        private httpClient: HttpClient
    ) {
        super();
    }

    public get(cnpj: string | null, razaoSocial: string | null, idEmpresaGrupo: number | null, paginaAtual?: number): Observable<ListaEmpresaResponse> {
        let params = new HttpParams();

        if (cnpj) {
            params = params.set('cnpj', cnpj);
        }

        if (razaoSocial) {
            params = params.set('razaoSocial', razaoSocial);
        }

        if (idEmpresaGrupo) {
            params = params.set('idEmpresaGrupo', idEmpresaGrupo.toString());
        }


        if (paginaAtual) {
            params = params.set('paginaAtual', paginaAtual.toString());
        }


        return this.httpClient
            .get<ListaEmpresaResponse>(environment.urlApiUsuario + `Empresa/admin`, {
                headers: this.addHeaderToken().headers,
                params: params
            }).pipe(catchError(this.handleError));
    }

    public getAll(apenasEmpresasSemGrupo: boolean = false): Observable<ListaEmpresaResponse> {
        return this.httpClient
            .get<ListaEmpresaResponse>(environment.urlApiUsuario + `Empresa/admin/lookup?apenasEmpresasSemGrupo=${apenasEmpresasSemGrupo}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public excluir(idEmpresa: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(
                environment.urlApiUsuario + `Empresa/admin/idEmpresa/${idEmpresa}`,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public Incluir(EmpresaRequest: EmpresaRequest): Observable<EmpresaCadastroResponse> {
        return this.httpClient
            .post<EmpresaCadastroResponse>(environment.urlApiUsuario + `Empresa/admin`, EmpresaRequest, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public Alterar(idEmpresa: number, EmpresaRequest: EmpresaRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(
                environment.urlApiUsuario + `Empresa/admin/idEmpresa/${idEmpresa}`,
                EmpresaRequest,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public ObterPorId(idEmpresa: number): Observable<EmpresaResponse> {
        return this.httpClient
            .get<EmpresaResponse>(
                environment.urlApiUsuario + `Empresa/admin/idEmpresa/${idEmpresa}`,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public ObterCasasDecimaisPorId(idEmpresa: number): Observable<CasasDecimaisResponse> {
        return this.httpClient
            .get<CasasDecimaisResponse>(
                environment.urlApiUsuario + `Empresa/admin/casasDecimais/idEmpresa/${idEmpresa}`,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public AlterarCasasDecimais(idEmpresa: number, casasDecimaisRequest: CasasDecimaisRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(
                environment.urlApiUsuario + `Empresa/admin/casasDecimais/idEmpresa/${idEmpresa}`,
                casasDecimaisRequest,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }
}